<script setup lang="ts">
import { RotateCcw } from "lucide-vue-next";

defineProps<{
  title: string;
  description: string;
  actionLabel: string;
}>();

const emit = defineEmits<{
  reset: [];
}>();
</script>

<template>
  <section
    class="overflow-hidden bg-white px-4 py-6 sm:px-7 sm:py-8 lg:px-9 lg:py-9"
  >
    <div class="flex flex-col items-center text-center">
      <img
        src="/images/search/empty-professionals.webp"
        alt=""
        class="h-auto w-full max-w-[760px] select-none object-contain"
        aria-hidden="true"
      />

      <h2
        class="mt-4 max-w-[760px] font-gabarito text-xl font-bold leading-tight tracking-[-0.015em] text-app-text sm:text-2xl"
      >
        {{ title }}
      </h2>

      <p
        class="mt-2 max-w-[620px] text-sm leading-6 text-app-muted md:text-base"
      >
        {{ description }}
      </p>

      <button
        type="button"
        class="mt-5 inline-flex h-11 items-center gap-2 rounded-[9px] bg-primary px-5 text-sm font-semibold text-white transition duration-300 hover:bg-primary-400"
        @click="emit('reset')"
      >
        <RotateCcw class="size-3.5" />
        {{ actionLabel }}
      </button>
    </div>
  </section>
</template>
